@import "~animatewithsass/animate.scss";


.Select.Select--single {
  font-family: sans-serif;
  font-weight: 100;
  .Select-control {
    border-radius: 6px;
    border: none !important;
    height: 45px;
    box-shadow: 0 3px 2px 0 black !important;
    cursor: pointer;
    &:hover {
      box-shadow: 0 3px 2px 0 black !important;
    }
    .Select-multi-value-wrapper {
      .Select-value {
        padding-top: 4px;
        .Select-value-label {
          font-size: 15px !important;
        }
      }
    }
  }
}

.Select.Select--multi {
  font-family: sans-serif;
  font-weight: 100;
  .Select-control {
    border-radius: 6px;
    border: none !important;
    height: 45px;
    box-shadow: 0 3px 2px 0 black !important;
    cursor: pointer;
    &:hover {
      box-shadow: 0 3px 2px 0 black !important;
    }
    .Select-multi-value-wrapper {
      padding-top: 4px;
      .Select-value {
        border: 0;
        border-radius: 10px;
        margin: 5px;
        .Select-value-icon {
          font-size: 17px;
          float: right;
          border-right: 0;
          padding-left: 7px;
          padding-right: 7px;
          margin: 3px;
          border-radius: 10px;
          border-right: 0;
        }
        .Select-value-label {
          border-radius: 10px;
          padding: 7px;
        }
      }
    }
  }
}

.Select-menu-outer {
  @include fadeInDown;
}

.Select.is-open {
  .Select-menu-outer {
    @include fadeInDown;
  }
}

.Select:not(.is-open) {
  .Select-menu-outer {
    @include fadeOutUp;
  }
}

.Select-placeholder {
  padding-top: 5px;
}

.is-open > .Select-control {
  border: none !important;
  border-radius: 6px !important;
}

.is-open > .Select-control .Select-arrow {
  border-color: transparent transparent white !important;
  border-width: 0 7px 7px !important;
}

.is-focused:not(.is-open) > .Select-control {
  box-shadow: 0 3px 2px 0 black !important;
}

.Select-clear-zone {
  display: none !important;
}

.Select-arrow-zone {
  width: 40px !important;
  border-left: 2px solid #1B3241;
}

.Select-arrow {
  border-color: white transparent transparent !important;
  border-width: 8px 7px 1.5px !important;
}

.placement-top {
  .Select-menu-outer {
    margin-bottom: 10px !important;
    border-radius: 5px !important;
    top: auto;
    bottom: 100%;
    &:after {
      content: '';
      position: absolute;
      top: 100%;
      right: 3%;
      margin: 0 auto;
      width: 0;
      height: 0;
      transform: rotate(180deg);
    }
  }
}

.Select-menu-outer {
    margin-top: 10px !important;
    border-radius: 5px !important;
    width: 100%;
    background-color: #1B3241;
    color: #fff !important;
    &:after {
      content: '';
      position: absolute;
      top: -4%;
      right: 3%;
      margin: 0 auto;
      width: 0;
      height: 0;
    }
}


.Select-menu {
}

.Select-option {
  background-color: inherit;
  color: #fff;


  cursor: pointer;
  display: block;
  border-radius: 10px;
  margin-left: 3px !important;
  margin-right: 3px !important;
  &:last-child {
    border-radius: 10px !important;
  }
}

.Select-option.is-focused {
  color: #fff;
  background-color: #2C495D;
}

@media (min-width: 768px) and (max-width: 1100px) {
  .Select {
    .Select-control {
      height: 40px !important;
    }
  }
  .Select-placeholder {
    padding-top: 3px !important;
  }
}



// WEBPACK FOOTER //
// webpack:///var/jenkins_home/workspace/azure-prod-baristadj-server/src/app/components/select/select.scss